import React from "react";
import { ToastContainer } from "react-toastify";
import BackButton from "./button/BackButton";
import LeftNav from "./leftSideNav/LeftNav";
import TopBar from "./topBar/TopBar";
import PropTypes from "prop-types";

const Starter = ({ ...props }) => {
  return (
    <div className="wrapper">
      <LeftNav />
      <ToastContainer />
      <div className="content-page">
        <TopBar title={props.topBarTitle} />
        <div className="content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-xl-12 col-lg-12 col-md-12">
                <div className="page-title-box">
                  <div className="float-right">
                    <ol className="breadcrumb m-0">
                      <li className="breadcrumb-item">
                        <a href="#">CMC</a>
                      </li>
                      {props.breadCrumb}
                    </ol>
                  </div>
                  <BackButton />
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-xl-12 col-lg-12 col-md-12">
                {props.children}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

Starter.propTypes = {
  children: PropTypes.any,
  breadCrumb: PropTypes.any,
  topBarTitle: PropTypes.string.isRequired
};

export default Starter;
